<template>
  <div class="ProductPresentation" :class="isZeborne ? 'zeborne' : 'mcp'">
    <div class="ProductPresentation-title">
      <h1>{{ productPresentation.name }}</h1>
    </div>
    <div class="ProductPresentation-header">
      
      <!-- Sku product -->
      <div class="ProductPresentation-sku">
        <template v-if="sticky">Référence constructeur : </template> 
        <template v-else>REF</template> 
        {{ productPresentation.baRefConstructeur }}
      </div>
      
      <!-- Rate and Reviews -->
      <div class="ProductPresentation-rating border">
        <a data-id-target="reviews" @click="scrollTo"></a>
        <StarRating
          v-if="!sticky"
          :rating="Number(productReviewsAverage.rate)"
          v-bind:increment="0.1"
          v-bind:read-only="true"
          v-bind:max-rating="5"
          v-bind:star-size="14"
        ></StarRating>
        <span>{{ productReviewsAverage.count }} avis</span>
      </div>

      <!-- Break line mobile -->
      <div class="break"></div>

      <!-- Social network share links -->
      <div class="Social-Share__container" v-if="shareLinkOrdered">
          <p>Partager :</p>

          <ul v-if="shareLinkOrdered.length > 0" class="Social-Share__buttons">
            <li 
              class="share__link"
              v-for="(socialMedia, key) in shareLinkOrdered" 
              :key="key"
              @click="decodeUrls($event)"
              :data-link="socialMedia.infos.url"
            >
              <svg v-svg :symbol="svgSymbol[socialMedia.media]" size="0 0 25 25" role="presentation" class="icon--inline mail" :class="`icon-${socialMedia.media}`"></svg> 
            </li>
          </ul>
      </div>
      

       <!--  Question / Reponse was commented -->
       <!-- <div class="ProductPresentation-questions border">
        <a data-target="">Questions / Réponses</a>
      </div> -->
      <!-- <div class="Product-subTitle desktopOnly" v-html="productPresentation.shortDescription"></div> -->

    </div>
  </div>
</template>

<script>
import "@/components/Product/ProductPresentation/ProductPresentation.scss";
import StarRating from "vue-star-rating";
import { mapGetters } from "vuex";
import EventBus from "@/event-bus";

export default {
  name: "ProductPresentation",
  components: {
    StarRating,
  },

  props : {
    sticky: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      shareLinkOrdered: this.mediaShareLinks,
      svgSymbol : {
        facebook:"Fb",
        whatsapp: "Wapp",
        twitter: "Tw",
        linkedin: "In",
        mail: "Mail",
      }
    };
  },

  methods: {
    scrollTo (event) {
      EventBus.$emit("action-scroll", event);
    },

    decodeUrls(e) {
      let attribute = e.currentTarget.getAttribute("data-link"); 
      var newWindow = window.open(encodeURI(decodeURIComponent(window.atob(attribute))));                    
      newWindow.focus();
    },

    sortMediasList() {
      this.shareLinkOrdered = this.mediaShareLinks
                              .filter(media => media.infos.url.length > 0)
                              .sort((a, b) => {
                                return parseInt(a.infos.front_order) - parseInt(b.infos.front_order)
                              })
    }
  },

  mounted() {
    this.sortMediasList()
  },

  watch: {
      mediaShareLinks() {
        this.sortMediasList()
      },
  },

  computed: {
    ...mapGetters({
      productPresentation: "getProductPresentation",
      productReviewsAverage: "getProductReviewsAverage",
      isZeborne: "isZeborne",
      mediaShareLinks: "getMediaSocialShareLinks" 
    }),
  },
};
</script>

